import { SubcategoryAllocation } from '../types/zoneMapType';

export interface ValidationResult {
  isValid: boolean;
  sum: number;
  errors: string[];
}

export function validateAllocations(allocations: SubcategoryAllocation[]): ValidationResult {
  const errors: string[] = [];

  if (allocations.length === 0) {
    return { isValid: false, sum: 0, errors: ['At least one subcategory allocation is required'] };
  }

  for (const allocation of allocations) {
    if (allocation.percentage < 0 || allocation.percentage > 100) {
      errors.push(`Percentage for "${allocation.subcategoryName}" must be between 0 and 100`);
    }
  }

  const sum = allocations.reduce((acc, a) => acc + a.percentage, 0);

  if (sum !== 100) {
    errors.push(`Percentages must sum to 100 (current sum: ${sum})`);
  }

  return { isValid: errors.length === 0, sum, errors };
}

export function sanitizePercentage(value: number): number | null {
  if (value < 0 || value > 100) {
    return null;
  }
  return Math.round(value);
}
